<template>

    <SubHeader title="Mon Compte" :breads="[{ name: 'Mon compte' }]" />

    <div class="col-lg-12">
        <div class="">
            <div class="card-body">

                <!-- Profile Cover -->
                <div class="profile-cover">
                    <div class="profile-cover-img-wrapper">
                        <img class="profile-cover-img" src="@/assets/img/1920x400/img1.jpg" alt="Image Description">
                    </div>
                </div>
                <!-- End Profile Cover -->

                <!-- Profile Header -->
                <div class="text-center align-items-center justify-content-center d-flex  mb-5"
                    style="flex-direction: column">
                    <div class="avatar avatar-xxl avatar-circle profile-cover-avatar">
                        <img class="avatar-img" src="@/assets/img/img1.jpg" alt="Image Description">
                        <span
                            :class="!user?.status ? 'avatar-status avatar-status-danger' : 'avatar-status avatar-status-success'"></span>
                    </div>
                    <!-- End Avatar -->
                    <div class="spinner-grow" role="status" v-if="userIsLoading">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <h1 v-else class="page-header-title">
                        {{ user.firstname ?? "" }} {{ user.lastname ?? "" }}
                    </h1>
                </div>
                <div class="tab-content" id="notificationTabContent">
                    <div class="tab-pane fade show active" id="notificationNavOne" role="tabpanel"
                        aria-labelledby="notificationNavOne-tab">
                        <div class="row">
                            <div class="col-lg-4">

                                <div id="accountSidebarNav"></div>

                                <!-- Card -->
                                <div class="card mb-3 mb-lg-5">
                                    <!-- Header -->
                                    <div class="card-header">
                                        <h4 class="card-header-title">Profile</h4>
                                    </div>
                                    <!-- End Header -->

                                    <!-- Body -->
                                    <div class="card-body">
                                        <ul class="list-unstyled list-py-2 text-dark mb-0">
                                            <li class="pb-0"><span class="card-subtitle">A propos </span></li>
                                            <li><i class="bi-person dropdown-item-icon"></i> {{ user.firstname
                                                ?? "" }}
                                                {{ user.lastname ?? "" }} </li>
                                            <li><i class="bi-at dropdown-item-icon"></i> {{ user.email ?? "" }}
                                            </li>

                                            <li class="pt-4 pb-0"><span class="card-subtitle">Roles</span></li>

                                            <li><i class="bi-building dropdown-item-icon"></i> <span
                                                    v-for="(role, i) in user.roles" :key="i"
                                                    class="badge bg-soft-primary text-dark ml-2 mr-2 ">{{ role.name
                                                    }}</span>
                                                <span class="text-primary " style="cursor:pointer"
                                                    v-if="!user?.roles?.length">+
                                                    Ajouter un role</span>
                                            </li>

                                            <li class="pt-4 pb-0"><span class="card-subtitle">Caracterisation
                                                    suivie</span></li>
                                            <i class="bi-stickies dropdown-item-icon"></i> <span
                                                v-for="(role, i) in user?.followed_characterizations" :key="i"
                                                class="badge bg-soft-primary text-dark " style="margin: 5px;">{{
                                                    role.name
                                                }}</span>
                                            <span class="text-primary " style="cursor:pointer"
                                                v-if="!user?.followed_characterizations?.length">
                                                Aucune caracterisation trouvée</span>
                                        </ul>
                                    </div>
                                    <!-- End Body -->
                                </div>

                            </div>

                            <div class="col-lg-8">
                                <div class="d-grid gap-3 gap-lg-5">
                                    <div class="row">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-header-title">Modifier profile</h4>
                                            </div>
                                            <div class="card-body">
                                                <form @submit.prevent="prepareBeforeSubmit">

                                                    <div class="mb-3">
                                                        <label class="form-label" for="user_lastname">Nom</label>
                                                        <input required type="text" name="user_lastname"
                                                            v-model="data.lastname" id="user_lastname"
                                                            class="form-control" placeholder="Nom">
                                                    </div>
                                                    <div class="mb-3">
                                                        <label class="form-label" for="user_firstname">Prénom(s)</label>
                                                        <input type="text" name="user_firstname"
                                                            v-model="data.firstname" id="user_firstname"
                                                            class="form-control" placeholder="Prénom(s)">
                                                    </div>
                                                    <div class="mb-3">
                                                        <label class="form-label" for="user_email">Email</label>
                                                        <input required type="text" name="user_email" id="user_email"
                                                            :value="data.email" readonly disabled class="form-control"
                                                            placeholder="Email">
                                                    </div>




                                                    <div class="justify-content-end d-flex">
                                                        <button class="btn btn-primary text-white" type="submit">
                                                            <span class="form-check-default">
                                                                <i class="bi-pencil mr-1"></i>Modifier
                                                            </span>
                                                        </button>
                                                    </div>

                                                </form>



                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="card">
                                            <div class="card-header">
                                                <h4 class="card-header-title">Modifier Mot de passe</h4>
                                            </div>
                                            <div class="card-body">
                                                <form @submit.prevent="handlePassword">



                                                    <div class="mb-3">
                                                        <label class="form-label" for="password">Ancien Mot de
                                                            passe</label>


                                                        <input required type="password"
                                                            name="password" id="password"
                                                            v-model="passwordForm.oldPassword" class="form-control"
                                                            placeholder="********" value="">
                                                    </div>
                                                    <div class="mb-3">
                                                        <label class="form-label" for="password">Nouveau Mot de
                                                            passe</label>


                                                        <input required type="password"
                                                            name="password" id="password"
                                                            v-model="passwordForm.password" class="form-control"
                                                            placeholder="********" value="">
                                                    </div>
                                                    <div class="mb-3">
                                                        <div class="d-flex justify-content-between">
                                                            <label class="form-label" for="password">Confirmer Mot de
                                                                passe</label>


                                                        </div>

                                                        <input required type="password"
                                                            name="password" 
                                                            v-model="passwordForm.confirmPassword" class="form-control"
                                                            placeholder="********" value="">
                                                    </div>




                                                    <div class="justify-content-end d-flex">
                                                        <button class="btn btn-primary text-white" type="submit">
                                                            <span class="form-check-default">
                                                                <i class="bi-pencil mr-1"></i>Modifier
                                                            </span>
                                                        </button>
                                                    </div>

                                                </form>



                                            </div>
                                        </div>
                                    </div>
                              

                                </div>


                            </div>
                        </div>
                    </div>

                    
                </div>

                <!-- End Row -->
            </div>

        </div>
    </div>


</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import notify from "@/utils/notify.js"
export default {
    name: "UserAuthProfile",
    components: {
        SubHeader,
        
    },
    data() {
        return {
            data: {
            },
            passwordForm: {
                password: "",
                oldPassword: null,
                confirmPassword: ""
            },
        }
    },
    computed: {
        ...mapFields("auth/user", {
            user: "item",
            userIsLoading: "isLoading",
            userIsSuccess: "isSuccess",
        }),
       
       

        ...mapFields("user/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated: "isUpdated",
            item: "items",
        }),
      


    },
    methods: {
       
        ...mapActions({
          
            handleSubmit: "user/update/update",
            resetUser: "user/update/resetData",
            getUserAuth: "auth/user/getUserAuth",
          
        }),
        prepareBeforeSubmit(){
            const currentData = { ...this.data };

            delete currentData?.profil
            delete currentData?.institution

            currentData.roles = this.data?.roles?.map(({ id }) => id)
            currentData.email = this.user?.email

            this.handleSubmit(currentData);
        },
        
        
        handlePassword() {

            if (this.passwordForm.confirmPassword !== this.passwordForm.password) {
                notify("Mot de passe incorrect")
                return
            }
            this.handleSubmit({ id: this.user.id,password: this.passwordForm.confirmPassword,oldPassword:this.passwordForm.oldPassword });
        },
       
    },

    
    watch: {
        isUpdated(val) {
            if (val) {
                
                notify("Utilisateur modifié avec success", "success")
                this.getUserAuth()
            }
        },
        userIsLoading(val){
            if(val){
                this.data = { ...this.user };
            }
        }
        

    },
    mounted() {
        this.data = { ...this.user };
    },
    unmounted() {
        this.resetUser()
        
    }
}
</script>
